export default __webpack_public_path__ + "static/assets/med_pill_round_flat_L1_solid_l_01_f.3bb974a3.png";